import React from 'react';
import PropTypes from 'prop-types';
import { IconWithTooltip } from '../icon/IconWithTooltip';

export const RemoveIcon = ({ handleClick }) => (
  <IconWithTooltip
    handleClick={handleClick}
    ariaLabel="remove"
    tooltip="Remove"
    icon="minus-circle"
  />
);


RemoveIcon.propTypes = {
// eslint-disable-next-line react/require-default-props
  handleClick: PropTypes.func,
};
